import { SvgWarningNew } from '@ui-kit'
import {
  DropDownOptionType,
  DropdownType,
  setClientDropdown,
  updateAuthUserSelectedTenant,
} from '@app-store'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { useEffect } from 'react'

const NegativeScreen = ({ message }: { message: string }) => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const selectedTenant = useAppSelector(
    (state: RootState) => state?.authUser?.selectedClientTenant
  )
  const onClientOptionChange = (value: DropdownType<DropDownOptionType>) => {
    if (value?.label === selectedTenant?.name_of_organization) {
      return
    }
    dispatch(updateAuthUserSelectedTenant(value?.value))
    navigate('/manage-queue')
  }

  useEffect(() => {
    dispatch(
      setClientDropdown({
        isVisible: true,
        onOptionChange: onClientOptionChange,
      })
    )
  }, [location])
  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center gap-[1.5rem] h-[25.75rem] mt-8.5 mx-0 border border-accent-100 rounded-lg relative ">
        <div>
          <SvgWarningNew />
        </div>
        <div className="font-light text-xs">{message}</div>
      </div>
    </div>
  )
}

export default NegativeScreen
